(function ($,_) {

  _.UI.extend('Loader', {
    init: function (box, options) {
      this.base(box, options);
      this.opt = $.extend({}, _.Loader.defaultOptions, this.opt);
      this.bindEvent();
    },
    bindEvent:function(){
      var me = this;
      me.box.on('click', function (e) {
        me.load($(this));
        
      //console.log($(this).attr('loader-link'));
      	if(!$(this).attr('loader-link')){
        	e.preventDefault();
      	}
      });
    },
    load:function(el,fn){
      var me = this,
          el = el || this.box,
          href = el.attr('data-href') || el.attr('href'),
      		targetEl = $(el.uiData('defer'));
      if(~href.indexOf('javascript')){
        return;
      }
      if (targetEl[0] && (!targetEl.attr('defer-loaded') || targetEl.attr('defer-loaded') != href)) {
        targetEl.addClass('loading');
        $.get(href, { r: ue.getTimeStamp(360000) }, function (txt) {
          targetEl.removeClass('loading');
          me.opt.append ? targetEl.append(txt) : targetEl.html(txt);
          $(document.body).trigger('appendHtml', targetEl);
          targetEl.attr('defer-loaded',href);
          me.opt.callback  && me.opt.callback(true,targetEl,el);
          fn && fn(true,targetEl);
        });
      }
      else{
        this.opt.callback  && this.opt.callback(false,targetEl,el);
        fn && fn(false,targetEl);        
      }
    }
  });

  _.Loader.defaultOptions = {
  };
})(jQuery,ue);